<style lang="less">
    .task-table-wrapped{
        .ivu-table-cell{
            padding:0;
        }
    }
</style>
<template>
  <Container style="height:100%;width:100%;position:relative;overflow:hidden">
    <div style="height:100px;border-bottom:1px solid var(--border)">
            <Button icon="md-add" @click="showModal=true"></Button>
            视图切换
            类型
            优先级
            负责人
            状态

    </div>
    <div class="flex-wrap task-table-wrapped" style="height:calc(100% - 140px);position:relative" ref="table-wrapper">
        <div style="height:100%;width:400px;border-right:1px solid var(--border);position:relative;">
            <Table size="small" border :columns="columns" :data="filteredItems" :height="tableHeight" style="width:100%;height:100%;"></Table>
        </div>
        <div style="height:100%;width:calc(100% - 400px);">
            <Table size="small" border :columns="columns2" :data="filteredItems" :height="tableHeight" style="width:100%;height:100%;"></Table>
        </div>
    </div>
    <div style="height:30px;border-top:1px solid var(--border)">
        任务:{{ items.length }}
    </div>
    <Modal v-model="showModal" title="新增任务" @on-ok="add">
        <Form :model="formData" :rules="rules" :label-width="80">
            <FormItem label="工作名称" prop="name">
                <Input v-model="formData.name" placeholder="请输入工作名称"></Input>
            </FormItem>
        </Form>
        {{ formData }}
    </Modal>

    <Drawer v-model="showTask" title="工作详情">
        {{ current }}
    </Drawer>
  </Container>
</template>

<script>
import Container from '@/components/app/container';
export default {
  components: {Container},
  data() {
    return {
      loading: false,
      showTask: false,
      current: null,
      tableHeight: 300,
      formData: {},
      showModal: false,
    };
  },
  mounted() {
    this.$nextTick(()=>{
      this.calcTableHeight();
      this.load();
    });
  },
  computed: {
    rules() {
      return {
        name: [{required: true, message: '请输入工作名称', trigger: 'blur'}],
      };
    },
    items() {
      return this.$store.getters['task2/tasks'] || [];
    },
    canUndo() {
      return this.$store.getters['task2/canUndo'];
    },
    canRedo() {
      return this.$store.getters['task2/canRedo'];
    },
    filteredItems() {
      return this.items;
    },
    columns() {
      return [{
        key: 'type',
        title: ' ',
        width: 40,
        align: 'center',
        renderHeader: (h, column)=>{
          const domIcon =h('BaseIcon', {props: {icon: 'md-apps', size: 16}});
          return h('div', {class: 'flex-wrap flex-center', style: 'width:100%'}, [domIcon]);
        },
        render: (h, {row})=>{
          const iconmap = {};
          const domIcon =h('BaseIcon', {props: {icon: 'md-calendar', size: 16}});
          return h('div', {class: 'flex-wrap flex-center'}, [domIcon]);
        },
      }, {
        key: '_showChildren',
        title: ' ',
        width: 40,
        align: 'center',
        renderHeader: (h, column)=>{
          const _showChildren = column.row._showChildren;
          const domIcon =h('BaseIcon', {props: {icon: _showChildren?'md-add':'md-remove', size: 16}});
          return h('div', {class: 'flex-wrap flex-center', style: 'width:100%', on: {
            click: ()=>{
              this.$store.dispatch('task2/toggleExpand', row.id);
            },
          }}, [domIcon]);
        },
        render: (h, {row})=>{
          const iconmap = {};
          const domIcon =h('BaseIcon', {props: {icon: 'md-calendar', size: 16}});
          return h('div', {class: 'flex-wrap flex-center'}, [domIcon]);
        },
      }, {
        key: 'name',
        title: '工作名称',
        minWidth: 200,
        align: 'center',
        render: (h, {row})=>{
          const domName = h('span', {style: `font-weight:bold;color:var(--primary);cursor:pointer;margin-left:${row.level*10}px`,
            on: {
              click: ()=>{
                this.current = row;
                this.showTask = true;
              },
            },
          }, row.name);
          const domTitle = h('div', {class: 'flex-wrap', style: 'padding:0 10px;'}, [domName]);
          return domTitle;
        },
      }, {
        width: 100,
        title: '操作',
        align: 'center',
        render: (h, {row})=>{
          const buttons = [];
          buttons.push(h('Button', {props: {'size': 'small', 'icon': 'md-add'}, style: 'margin-right:5px',
            on: {
              click: ()=>{
                this.formData = {
                  parent_id: row.id,
                  level: (row.level || 0)+1,
                };
                this.showModal = true;
              },
            }}));
          buttons.push(h('Button', {props: {'size': 'small', 'icon': 'md-trash'}, style: 'margin-right:5px'}));
          return h('div', {class: 'flex-wrap flex-center'}, buttons);
        },
      }];
    },
    columns2() {
      return [{
        key: 'plan_started_at',
        align: 'center',
        width: 120,
        title: '计划开始',
      }, {
        key: 'started_at',
        align: 'center',
        width: 120,
        title: '实际开始',
      }, {
        key: 'plan_finished_at',
        align: 'center',
        width: 120,
        title: '计划完成',
      }, {
        key: 'finished_at',
        align: 'center',
        width: 120,
        title: '实际完成',
      }, {
        key: 'charger_id',
        width: 120,
        align: 'center',
        title: '负责人',
      }, {
        key: 'last_tracking',
        align: 'center',
        minWidth: 120,
        title: '工作进展',
      }];
    },
  },
  methods: {
    calcTableHeight() {
      const tableWrapper = this.$refs['table-wrapper'];
      const height = tableWrapper.clientHeight;
      this.tableHeight = height;
    },
    load() {
      this.$store.dispatch('task2/load');
    },
    add() {
      this.$store.dispatch('task2/do', {action: 'add', params: this.formData}).then((res)=>{
        this.formData = {};
        this.Success({title: '操作成功', desc: '任务已添加成功'});
      });
    },
    remove(id) {
      this.$store.dispatch('task2/do', {action: 'remove', params: id}).then((res)=>{
        this.formData = {};
        this.Success({title: '操作成功', desc: '任务已删除成功'});
      });
    },
  },
};
</script>

<style>

</style>
